import formSportRoomCustomization from './formSportRoomCustomization';
import formSportRoomEnvironment from './formSportRoomEnvironment';
import formSportRoomGeneral from './formSportRoomGeneral';
import formSportRoomImagesAndroid from './formSportRoomImagesAndroid';
import formSportRoomImagesQuest from './formSportRoomImagesQuest';
import formSportRoomImagesVisionOS from './formSportRoomImagesVisionOS';
import formSportRoomTeams from './formSportRoomTeams';
import formSportsRoomMinigames from './formSportsRoomMinigames';


export default {
  title: 'Room Customization',
  attributeName: 'sportRoomCustomization',
  getURL: 'space/appId/customization',
  createURL: '',
  updateURL: 'customization/appId',
  removeURL: '',
  sessionParams: ['appId'],
  // saveIdSessionNameAs: 'id',
  // idAttribute: 'appId',
  noArea:true,
  formConfig: [
    formSportRoomGeneral,
    formSportRoomCustomization,
    formSportRoomImagesQuest,
    formSportRoomImagesAndroid,
    formSportRoomImagesVisionOS,
    formSportRoomEnvironment,
    formSportsRoomMinigames, 
    formSportRoomTeams
  ],
  autoUpdate: false,
};
